module.exports = __webpack_public_path__ + "assets/img/logo_my.652ad1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_my.jpg
// module id = 3H1t
// module chunks = 166